// @flow
import type {
  UiAction,
} from '../types';

import {
  actionTypes,
} from '.';


export const setUiState = (
  keyOrRootValues: any,
  maybeValues: any,
): UiAction => ({
  type: actionTypes.SET_UI_STATE,
  payload: {
    keyOrRootValues,
    maybeValues,
  },
});

export const clearCalendarSelection = (): UiAction => ({
  type: actionTypes.CLEAR_CALENDAR_SELECTION,
});

export const selectSidebarItems = (
  payload: Array<string>,
): UiAction => ({
  type: actionTypes.SELECT_SIDEBAR_ITEMS,
  payload,
});

export const clearSidebarItems = (
  payload: GroupByType,
): UiAction => ({
  type: actionTypes.CLEAR_SIDEBAR_ITEMS,
  payload,
});

export const clearAllSidebarItems = (): UiAction => ({ type: actionTypes.CLEAR_ALL_SIDEBAR_ITEMS });

export const selectSidebarItemRequest = (
  payload: number,
): UiAction => ({
  type: actionTypes.SELECT_SIDEBAR_ITEM_REQUEST,
  payload,
});

export const refreshRequest = () => ({
  type: actionTypes.REFRESH_REQUEST,
});

export const addFlag = (
  payload: any,
): UiAction => ({
  type: actionTypes.ADD_FLAG,
  payload,
});

export const deleteFlag = (
  id: Id,
): UiAction => ({
  type: actionTypes.DELETE_FLAG,
  id,
});
